var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconImpersonator = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1638347014229,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2065,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z",
    fill: "#FCD063",
    "p-id": 2066
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M840.512 119.488C915.008 208.416 960 322.912 960 448c0 282.752-229.248 512-512 512-125.088 0-239.584-44.992-328.512-119.488C213.408 952.64 354.304 1024 512 1024c282.752 0 512-229.248 512-512 0-157.696-71.36-298.592-183.488-392.512z",
    fill: "#F7B84E",
    "p-id": 2067
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 512c0 10.784 0.96 21.344 1.6 32h1020.768c0.704-10.656 1.632-21.216 1.632-32 0-80.448-19.072-156.256-52.128-224H52.128C19.072 355.744 0 431.552 0 512z",
    fill: "#35495C",
    "p-id": 2068
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M960 448c0 32.832-3.36 64.864-9.312 96h71.68c0.704-10.656 1.632-21.216 1.632-32 0-80.416-18.752-156.32-51.808-224h-38.24C950.56 338.368 960 392.032 960 448z",
    fill: "#123247",
    "p-id": 2069
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M320 416m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z",
    fill: "#FCD063",
    "p-id": 2070
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M704 416m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z",
    fill: "#FCD063",
    "p-id": 2071
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M320 384c29.792 0 54.592 20.448 61.728 48 1.344-5.152 2.272-10.432 2.272-16 0-35.328-28.672-64-64-64s-64 28.672-64 64c0 5.568 0.928 10.848 2.272 16 7.136-27.552 31.936-48 61.728-48zM704 384c29.792 0 54.592 20.448 61.76 48 1.312-5.152 2.24-10.432 2.24-16 0-35.328-28.672-64-64-64s-64 28.672-64 64c0 5.568 0.928 10.848 2.24 16 7.168-27.552 31.968-48 61.76-48z",
    fill: "#F7B84E",
    "p-id": 2072
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M372.448 640c9.216 0 18.528 2.24 27.008 6.944 59.968 33.184 165.184 33.184 225.12 0 24.736-13.728 56.96-6.432 71.936 16.288 14.944 22.72 6.976 52.256-17.792 65.984-93.472 51.744-239.936 51.744-333.408 0-24.736-13.728-32.704-43.264-17.76-65.984 9.824-14.944 27.136-23.232 44.896-23.232z",
    fill: "#C98E3F",
    "p-id": 2073
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M327.552 695.2c9.824-14.944 27.136-23.2 44.896-23.2 9.216 0 18.528 2.208 27.008 6.912 59.968 33.216 165.184 33.216 225.12 0 24.736-13.728 56.96-6.4 71.936 16.288a43.422 43.422 0 0 1 4.384 8.576c4.928-13.024 4-27.808-4.384-40.544-14.976-22.72-47.2-30.016-71.936-16.288-59.936 33.184-165.152 33.184-225.12 0A55.578 55.578 0 0 0 372.448 640c-17.76 0-35.04 8.288-44.896 23.232-8.384 12.704-9.344 27.488-4.416 40.544a44.438 44.438 0 0 1 4.416-8.576z",
    fill: "#AB7934",
    "p-id": 2074
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconImpersonator);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_impersonator.ee77e7db3622c2920e8819994da125b7.svg";